import {
    dashboardIcon,
    purchaseIcon,
    sellInvoiceIcon,
    memoIcon,
    stockIcon,
    paymentIcon,
    expenseIcon,
    customerIcon,
    rolePermissionIcon,
    returnSidebarIcon,
} from '../assets/utils/images';

export const sections = [
    {
        title: 'All',
        items: [
            { name: 'Dashboard', slug: "/", icon: dashboardIcon, roles: ["Super Admin", "Admin", "Sales", "Finance"] },
            { name: 'Purchase', slug: "/purchase", icon: purchaseIcon, roles: ["Super Admin", "Admin", "Finance"] },
            { name: 'Sell/Invoice', slug: "/sell-invoice", icon: sellInvoiceIcon, roles: ["Super Admin", "Admin", "Sales", "Finance"] },
            { name: 'Returns', slug: "/returns", icon: returnSidebarIcon, roles: ["Super Admin", "Admin", "Sales", "Finance"] }
        ]
    },
    {
        title: 'Management',
        items: [
            { name: 'Memo', slug: "/memo", icon: memoIcon, roles: ["Super Admin", "Admin", "Sales", "Finance"] },
            { name: 'Stock', slug: "/stock", icon: stockIcon, roles: ["Super Admin", "Admin", "Sales", "Finance"] },
            { name: 'Payment', slug: "/payment", icon: paymentIcon, roles: ["Super Admin", "Admin", "Finance"] },
            { name: 'Expense', slug: "/expense", icon: expenseIcon, roles: ["Super Admin", "Admin", "Finance"] },
            { name: 'Customer', slug: "/customer", icon: customerIcon, roles: ["Super Admin", "Admin", "Sales"] },
            { name: 'Roles & Permission', slug: "/roles-permission", icon: rolePermissionIcon, roles: ["Super Admin", "Admin"] }
        ]
    },
    // {
    //     title: 'Other',
    //     items: [
    //         { name: 'Reports & Analytics', slug: "/reports-analytics", icon: reportAnalyticsIcon, roles: ["Super Admin", "Admin", "Finance"] }
    //     ]
    // }
];

export const COLOR_TYPE = [
    { label: 'White', value: 'White' },
    { label: 'Fancy', value: 'Fancy' },
];

export const WHITE_COLOR = [
    { value: 'D', label: 'D' }, { value: 'E', label: 'E' },
    { value: 'F', label: 'F' }, { value: 'G', label: 'G' },
    { value: 'H', label: 'H' }, { value: 'I', label: 'I' },
    { value: 'J', label: 'J' }, { value: 'K', label: 'K' },
    { value: 'L', label: 'L' }, { value: 'M', label: 'M' },
    { value: 'N', label: 'N' },
    { value: 'O-P', label: 'O-P' },
    { value: 'Q-R', label: 'Q-R' },
    { value: 'S-T', label: 'S-T' },
    { value: 'U-V', label: 'U-V' },
    { value: 'W-X', label: 'W-X' },
    { value: 'Y-Z', label: 'Y-Z' },
];

export const FANCY_COLOR = [
    { value: 'Yellow', label: 'Yellow' },
    { value: 'Yellow – Brown', label: 'Yellow – Brown' },
    { value: 'Yellow – Grey', label: 'Yellow – Grey' },
    { value: 'Yellow – Orange', label: 'Yellow – Orange' },
    { value: 'Yellow – Orangy', label: 'Yellow – Orangy' },
    { value: 'Yellow – Green', label: 'Yellow – Green' },
    { value: 'Yellowish – Orange', label: 'Yellowish – Orange' },
    { value: 'Yellowish – Brown', label: 'Yellowish – Brown' },
    { value: 'Yellowish – Green', label: 'Yellowish – Green' },
    { value: 'Pink', label: 'Pink' },
    { value: 'Pink – Purple', label: 'Pink – Purple' },
    { value: 'Pinkish - Purple', label: 'Pinkish - Purple' },
    { value: 'Pinkish - Brown', label: 'Pinkish - Brown' },
    { value: 'Pink – Brown', label: 'Pink – Brown' },
    { value: 'Brown', label: 'Brown' },
    { value: 'Brown - Yellow', label: 'Brown - Yellow' },
    { value: 'Brown - Pink', label: 'Brown - Pink' },
    { value: 'Brown - Orange', label: 'Brown - Orange' },
    { value: 'Browinsh - Greenish - Yellow', label: 'Browinsh - Greenish - Yellow' },
    { value: 'Browinsh - Orangy - Yellow', label: 'Browinsh - Orangy - Yellow' },
    { value: 'Purple – Pink', label: 'Purple – Pink' },
    { value: 'Greenish', label: 'Greenish' },
    { value: 'Greenish - Yellow', label: 'Greenish - Yellow' },
    { value: 'Orange - Yellow', label: 'Orange - Yellow' },
    { value: 'Orangy - Yellow', label: 'Orangy - Yellow' },
    { value: 'Gray - Greenish - Yellow', label: 'Gray - Greenish - Yellow' },
    { value: 'Gray - Yellowish - Green', label: 'Gray - Yellowish - Green' },
    { value: 'Black', label: 'Black' },
    { value: 'Blue', label: 'Blue' },
    { value: 'Chameleon', label: 'Chameleon' },
    { value: 'Champagne', label: 'Champagne' },
    { value: 'Cognac', label: 'Cognac' },
    { value: 'Gray', label: 'Gray' },
    { value: 'Green', label: 'Green' },
    { value: 'Orange', label: 'Orange' },
    { value: 'Purple', label: 'Purple' },
    { value: 'Red', label: 'Red' },
    { value: 'Violet', label: 'Violet' },
    { value: 'White', label: 'White' },
    { value: 'Green – Grey', label: 'Green – Grey' },
    { value: 'Green – Yellow', label: 'Green – Yellow' },
    { value: 'Orange – Brown', label: 'Orange – Brown' },
    { value: 'Other', label: 'Other' },
];

export const SHADE = [
    { value: 'None', label: 'None' },
    { value: 'Mixed', label: 'Mixed' },
    { value: 'Yellow', label: 'Yellow' },
    { value: 'Brown', label: 'Brown' },
    { value: 'Faint Brown', label: 'Faint Brown' },
    { value: 'Green', label: 'Green' },
    { value: 'Faint Green', label: 'Faint Green' },
    { value: 'Grey', label: 'Grey' },
    { value: 'Black', label: 'Black' },
    { value: 'Pink', label: 'Pink' },
    { value: 'Blue', label: 'Blue' },
    { value: 'Light Brown', label: 'Light Brown' },
    { value: 'Very Light Brown', label: 'Very Light Brown' },
    { value: 'Other', label: 'Other' },
];

export const FANCY_INTENSITY = [
    { value: 'Fancy Vivid', label: 'Fancy Vivid' },
    { value: 'Fancy Deep', label: 'Fancy Deep' },
    { value: 'Fancy Intense', label: 'Fancy Intense' },
    { value: 'Fancy', label: 'Fancy' },
    { value: 'Fancy Light', label: 'Fancy Light' },
    { value: 'Light', label: 'Light' },
    { value: 'Very Light', label: 'Very Light' },
    { value: 'Fancy Dark', label: 'Fancy Dark' },
    { value: 'Faint', label: 'Faint' },
    { value: 'Fancy Brownish', label: 'Fancy Brownish' },
    { value: 'Fancy Deep Brownish', label: 'Fancy Deep Brownish' },
    { value: 'Fancy Light Brownish', label: 'Fancy Light Brownish' },
];

export const LAYOUTS = {
    DASHBOARD_LAYOUT: "DASHBOARD_LAYOUT",
    MAIN: "MAIN"
}
